import { useState } from 'react';
import WidgetModel from '@mm/state/model/WidgetModel';

type MatchedProps = {
  widget: WidgetModel;
  [key: string]: any;
};

// In Bot Builder use setEditMode from makeWidget
export const useEditMode = (
  props: MatchedProps,
  field: keyof WidgetModel['config'] = 'body',
) => {
  const { widget } = props;
  const [editMode, setEditMode] = useState(!widget.config[field]);

  const setEditModeIfChanged = (newEditMode: boolean) => {
    if (editMode !== newEditMode) {
      setEditMode(newEditMode);
    }
  };

  return { editMode, setEditMode: setEditModeIfChanged };
};
